const glossary = {
  getKeywords: async function() {
    return await this.$store.getters
      .fetcher({
        query: `{ keywords {
          Keyword_Id
          Name
          Definition
          Applicability
        }
      }`
      })
      .then(r => {
        return r.data.keywords;
      });
  },
  getApplicableKeywords: async function(applicabilityFlag) {
    return await this.$store.getters
      .fetcher({
        query:
          `{ applicableKeywords(applicabilityFlag: ` +
          applicabilityFlag +
          `) {
          Keyword_Id
          Name
          Definition
          Applicability
        }
      }`
      })
      .then(r => {
        return r.data.applicableKeywords;
      });
  },
  createKeyword: async function(keywordToCreate) {
    var query = `
    mutation($name: String!, $definition: String!, $applicability: Int!) {
      CreateKeyword(name: $name, definition: $definition, applicability: $applicability) {
        Keyword_Id
      }
    }`;
    var variables = {
      name: keywordToCreate.Name.trim(),
      definition: keywordToCreate.Definition.trim(),
      applicability: parseInt(keywordToCreate.Applicability)
    };

    return await this.$store.getters.fetcher({ query, variables }).then(r => {
      keywordToCreate.Keyword_Id = r.data.CreateKeyword.Keyword_Id;
      return keywordToCreate;
    });
  },
  updateKeyword: async function(keywordToUpdate) {
    var query = `
    mutation($keywordId: Int!, $name: String!, $definition: String!, $applicability: Int!) {
      UpdateKeyword(keywordId: $keywordId, name: $name, definition: $definition, applicability: $applicability) {
        Keyword_Id
      }
    }`;
    var variables = {
      keywordId: parseInt(keywordToUpdate.Keyword_Id),
      name: keywordToUpdate.Name.trim(),
      definition: keywordToUpdate.Definition.trim(),
      applicability: parseInt(keywordToUpdate.Applicability)
    };

    return await this.$store.getters.fetcher({ query, variables }).then(() => {
      return keywordToUpdate;
    });
  },
  deleteKeyword: async function(keywordToDelete) {
    var query = `
    mutation($keywordId: Int!) {
      DeleteKeyword(keywordId: $keywordId) 
    }`;
    var variables = {
      keywordId: parseInt(keywordToDelete.Keyword_Id)
    };

    return await this.$store.getters.fetcher({ query, variables }).then(() => {
      return keywordToDelete;
    });
  }
};

export { glossary };
